import React, { useState, useEffect } from "react";
import { Button } from "@mui/material";
import TextField from "@material-ui/core/TextField";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import Swal from "sweetalert2";
import { useNavigate, useParams, Link } from "react-router-dom";

import { useForm } from "react-hook-form";
import axios from "axios";

const useStyles = makeStyles((theme) => ({
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
}));

export default function ResetPassword() {
  const { company } = useParams();
  let history = useNavigate();
  const classes = useStyles();
  const [show, setShow] = useState(false);
  const [disable, setDisable] = useState(false);
  const [counter, setCounter] = useState(5);

  useEffect(() => {
    counter > 0 && show && setTimeout(() => setCounter(counter - 1), 1000);
  }, [counter, show]);

  const resetPassWordURL = `${process.env.REACT_APP_SERVER_API}/clientUser/forgotPassword`;

  const {
    register,
    handleSubmit,
    setError,
    getValues,
    formState: { errors },
  } = useForm({});

  const onSubmit = async (data) => {
    const email = getValues("email");
    setShow(true);
    setDisable(true);
    await axios
      .put(resetPassWordURL, {
        email: email,
        company: company,
      })
      .then((res) => {
        setTimeout(() => {
          return history(`/login/${company}`);
        }, 5000);
      })
      .catch((err) => {
        Swal.fire({
          text: err.response?.data?.error?.message || "Something went wrong",
          icon: "error",
        });
      });
  };

  return (
    <div className="flex justify-center items-center h-screen flex-col">
      <div className="bg-white shadow-lg rounded-lg p-8 w-full max-w-md">
        <Typography component="h1" variant="h5">
          Reset My Password
        </Typography>
        <form
          className={classes.form}
          onSubmit={handleSubmit(onSubmit)}
          noValidate
        >
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            id="email"
            label="Email Address"
            name="email"
            autoComplete="email"
            autoFocus
            {...register("email", {
              required: "Email name is required",
              pattern: {
                value:
                  /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/,
                message: "Please enter a valid email",
              },
            })}
          />
          {errors.email && (
            <p className="signUpErrorMessage">{errors.email.message}</p>
          )}
          <Button
            disabled={disable || company === "undefined"}
            type="submit"
            fullWidth
            variant="contained"
            color="primary"
            style={{ marginTop: "20px" }}
            className={classes.submit}
          >
            Reset My Password
          </Button>
          <Grid container>
            <Grid item xs>
              <Link
                style={{ float: "right", marginTop: "20px" }}
                to={`/resetpassword/${company}`}
              >
                sign In
              </Link>
            </Grid>
            {/* <Grid item>
              <Link style={{float:'right'}} href="/signUp" variant="body2">
                {"Don't have an account? Sign Up"}
              </Link>
            </Grid> */}
          </Grid>
        </form>
      </div>
      {show && (
        <h5 style={{ marginTop: "30px" }}>
          {" "}
          The reset link has been sent to you email!
        </h5>
      )}
      {show && (
        <h5 style={{ marginTop: "10px" }}>
          {" "}
          Redirect page to sign in in {counter} seconds
        </h5>
      )}
    </div>
  );
}
